import styled from '@emotion/styled/macro';
import { CardCvcElement } from '@stripe/react-stripe-js';

export const StyledCardCvcElement = styled(CardCvcElement)`
  color: ${({ theme }) => theme.color.black};
  font: normal normal 0.875rem/1.5rem ${({ theme }) => theme.font.gotham};
  padding: 0 1rem;
`;
